import { useState } from "react";
import { TabBase } from '../TabBase';
import type { IContentSwitcher } from "libs/design-system/src/types/content_switchers/content_switcher";
import styles from "./content-switcher.module.scss";

export const ContentSwitcher = ({
  tabsProps = [],
  alignment = 'horizontal',
}: IContentSwitcher) => {

  const [selectedTab, setSelectedTab] = useState("2");

  const handleTabClick = (tabId?: string) => {
    tabId && setSelectedTab(tabId);
  };

  return (
    <div
      data-cs-alignment={alignment}
      className={styles["content-switcher"]}
    >
      {
        tabsProps.map((tab, key: number) => {
          return (
            <TabBase
              key={`content-switcher-tab-${key + 1}`}
              {...tab}
              active={typeof tab.active === "boolean" ? tab.active : selectedTab === tab.id}
              onClickHandler={(e) => {
                tab.onClickHandler?.(e);
                handleTabClick(tab.id);
              }}
            />
          )
        })
      }
    </div>
  )
};